import React from 'react';
import authBg from '../../assets/images/auth/BG.jpg';
import './Auth.styles.css';
import ChatHelp from '../../components/chat-help/ChatHelp.component';
import { useTranslation } from 'react-i18next';
import VerifyMail from '../../components/auth/VerifyMail.component';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import MetaComp from '../../components/meta-comp/MetaComp.component';
import LegalLinks from '../../components/auth/LegalLinks.component';

const VerifyAccountPage = () => {
    const navigate = useNavigate();
    const { state } = useLocation();

    const [searchParams] = useSearchParams();
    const getId = searchParams.get('id');
    const getRefId = searchParams.get('refId');
    const { t } = useTranslation();

    React.useEffect(() => {
        !getId && state === null && navigate('/', { replace: true });
    }, [])

    return(
        <main className='cm-page-container cm-auth-page-container d-flex row mx-0'>
            <MetaComp title={t("verify_account_page_title")}/>
            <div className='col-sm-12 col-md-6  cm-auth-content-wrap d-flex flex-column'>
                <div className='cm-auth-content-inner col-12 flex-grow-1 d-flex flex-column justify-content-center'>
                    <div>
                        <div className="cm-txt-wrap">
                            <h2 className='h2 text-blue-gray-700 cm-fs-24 cm-mmc-font'>
                                {t("one_last_thing")}
                            <span className='d-block h1 text-primary fw-bold cm-fs-40'>
                            {t("verify_your_email")}
                            </span>
                            </h2>
                            <h4 className='h4 text-blue-800'>{t("complete_signup_email")} {!!state ? `"${state.email}"` : null}.</h4>
                        </div>

                        <hr className='cm-auth-hr bg-blue-gray-300' />

                        <VerifyMail t={t} id={getId} refId={getRefId} />
                    </div>
                </div>
                <LegalLinks />
            </div>
            <div className='col-sm-6 py-8 cm-auth-bg-container position-relative d-none d-lg-block d-md-block w-md-50' style={{ backgroundImage: `url('${authBg}')` }}>
                <ChatHelp />
            </div>
        </main>
    )

}

export default VerifyAccountPage;